import * as pdfjsLib from "pdfjs-dist";

// PDF.js worker: public/ içindeki dosya metin olarak çekilip blob URL olarak verilir — sunucu MIME ayarından bağımsız çalışır
let ready = null;
export function getPdfjs() {
  if (!ready) {
    ready = fetch(`${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`)
      .then((r) => { if (!r.ok) throw new Error("worker"); return r.text(); })
      .then((code) => { pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(new Blob([code], { type: "text/javascript" })); return pdfjsLib; })
      .catch(() => { ready = null; throw new Error("PDF görüntüleyici yüklenemedi"); });
  }
  return ready;
}
